var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasBindData.isExistShop
    ? _c(
        "div",
        [
          _c(
            "el-card",
            { staticClass: "prodinfo--card" },
            [
              _c("z-search", {
                ref: "search",
                attrs: { configs: _vm.configs },
                on: { "do-query": _vm.query },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "category_ids",
                      fn: function () {
                        return [
                          _c("el-cascader", {
                            attrs: {
                              dictKey: "category_ids",
                              placeholder: _vm.$t(
                                "stores::products-info::select_category"
                              ),
                              clearable: "",
                              filterable: "",
                              options: _vm.categoryList,
                              props: {
                                label: "name",
                                value: "id",
                                children: "children",
                                checkStrictly: true,
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "mainEmpty",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "empty-cate" },
                                        [
                                          _c("p", [_vm._v("暂无类目")]),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: { click: _vm.onUpload },
                                            },
                                            [_vm._v("快速导入类目")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              281362392
                            ),
                            model: {
                              value: _vm.searchData["category_ids"],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchData,
                                  "category_ids",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "searchData['category_ids']",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2998645415
                ),
                model: {
                  value: _vm.searchData,
                  callback: function ($$v) {
                    _vm.searchData = $$v
                  },
                  expression: "searchData",
                },
              }),
            ],
            1
          ),
          _c(
            "el-card",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c(
                "div",
                {
                  staticClass: "prodinfo--list__btnWrap",
                  staticStyle: { "justify-content": "space-between" },
                },
                [
                  _c("div"),
                  _c(
                    "div",
                    { staticStyle: { "text-align": "right" } },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "stores::products-info::uploadLog",
                              expression: "'stores::products-info::uploadLog'",
                            },
                          ],
                          staticClass: "btn-item",
                          on: { click: _vm.importLog },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("stores::products-info::import_log")
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "stores::products-info::upload",
                              expression: "'stores::products-info::upload'",
                            },
                          ],
                          staticClass: "btn-item",
                          on: { click: _vm.onUpload },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("stores::products-info::import"))
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "stores::products-info::export",
                              expression: "'stores::products-info::export'",
                            },
                          ],
                          staticClass: "btn-item",
                          attrs: { loading: _vm.exportLoading },
                          on: { click: _vm.exportGoods },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("stores::products-info::export")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tableSelections.length,
                      expression: "tableSelections.length",
                    },
                  ],
                  staticClass: "prodinfo--list__tips",
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("stores::products-info::select_num", {
                          x: _vm.tableSelections.length,
                        })
                      )
                    ),
                  ]),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("stores::products-info::use_stock")) +
                        "：" +
                        _vm._s(_vm.totalAvailableInventory || 0)
                    ),
                  ]),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("stores::products-info::goods_stock")) +
                        "：" +
                        _vm._s(_vm.totalSpuInventory || 0)
                    ),
                  ]),
                ]
              ),
              _c("z-table", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "prodinfo--table",
                attrs: {
                  "cell-class-name": _vm.cellClass,
                  columns: _vm.tableColumns,
                  data: _vm.tableData,
                  "max-height": 520,
                  "row-class-name": _vm.tableRowClassName,
                  pagination: _vm.pagination,
                  "tree-props": { children: "skus" },
                  "row-key": "id",
                },
                on: {
                  "update:pagination": function ($event) {
                    _vm.pagination = $event
                  },
                  "page-change": _vm.handlePageChange,
                  "selection-change": _vm.handleSelectTable,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "prodinfo--table__imgTd",
                              staticStyle: { "line-height": "0" },
                            },
                            [
                              _c(
                                "el-popover",
                                {
                                  staticStyle: { "margin-right": "24px" },
                                  attrs: {
                                    placement: "top-start",
                                    trigger: "hover",
                                  },
                                },
                                [
                                  _c("ZImg", {
                                    staticStyle: {
                                      width: "250px",
                                      height: "250px",
                                    },
                                    attrs: { src: row.imageUrl },
                                  }),
                                  _c("ZImg", {
                                    staticClass: "images",
                                    attrs: {
                                      slot: "reference",
                                      src: row.imageUrl,
                                    },
                                    slot: "reference",
                                  }),
                                ],
                                1
                              ),
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "prodinfo--table__title",
                                    attrs: { slot: "tooptip" },
                                    slot: "tooptip",
                                  },
                                  [_vm._v(_vm._s(row.title))]
                                ),
                                row.skuId
                                  ? _c(
                                      "div",
                                      { staticClass: "prodinfo--table__spu" },
                                      [_vm._v("SKU: " + _vm._s(row.skuId))]
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "prodinfo--table__spu" },
                                      [
                                        _vm._v(
                                          " SPU: " + _vm._s(row.spuId) + " "
                                        ),
                                      ]
                                    ),
                                row.tags !== null &&
                                row.tags !== undefined &&
                                row.tags.length !== 0
                                  ? _c(
                                      "div",
                                      { staticClass: "tag-wrap" },
                                      [
                                        _vm._l(
                                          row.tags.filter(function (
                                            value,
                                            valueIndex
                                          ) {
                                            return valueIndex < 3
                                          }),
                                          function (item, index) {
                                            return _c(
                                              "el-tag",
                                              {
                                                key: index,
                                                staticClass:
                                                  "tag-cell-item common-tag",
                                                staticStyle: {
                                                  "margin-right": "4px",
                                                },
                                                attrs: {
                                                  size: "mini",
                                                  closable: "",
                                                  color: "#fff",
                                                  title: item.name,
                                                },
                                                on: {
                                                  close: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.releaseTag(
                                                      item,
                                                      row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(item.name) + " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        row.tags.length > 3
                                          ? _c(
                                              "el-dropdown",
                                              [
                                                _c(
                                                  "el-tag",
                                                  {
                                                    staticClass:
                                                      "common-tag expand-tag",
                                                    staticStyle: {
                                                      "margin-right": "2px",
                                                    },
                                                    attrs: {
                                                      size: "mini",
                                                      color: "#fff",
                                                    },
                                                  },
                                                  [_vm._v("...")]
                                                ),
                                                _c(
                                                  "el-dropdown-menu",
                                                  {
                                                    attrs: { slot: "dropdown" },
                                                    slot: "dropdown",
                                                  },
                                                  _vm._l(
                                                    row.tags,
                                                    function (item, index) {
                                                      return _c(
                                                        "el-dropdown-item",
                                                        { key: index },
                                                        [
                                                          _c(
                                                            "el-tag",
                                                            {
                                                              staticClass:
                                                                "product--table__tag",
                                                              attrs: {
                                                                size: "medium",
                                                                closable: "",
                                                              },
                                                              on: {
                                                                close:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.releaseTag(
                                                                      item,
                                                                      row
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.name
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "prodinfo--table__spu" },
                                  [
                                    _vm._v(
                                      " " + _vm._s(row.optionValueNames) + " "
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "purchasePrice",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          row.purchasePrice
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.priceFormat(row, "purchasePrice"))
                                ),
                              ])
                            : _c("span", [_vm._v("--")]),
                        ]
                      },
                    },
                    {
                      key: "compareAtPrice",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          row.compareAtPrice
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.priceFormat(row, "compareAtPrice"))
                                ),
                              ])
                            : _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v(_vm._s(_vm.editText.not_pricing)),
                              ]),
                        ]
                      },
                    },
                    {
                      key: "salePrice",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          row.salePrice
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.priceFormat(row, "salePrice"))
                                ),
                              ])
                            : _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v(_vm._s(_vm.editText.not_pricing)),
                              ]),
                        ]
                      },
                    },
                    {
                      key: "store",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.editText.use_stock) +
                                ": " +
                                _vm._s(
                                  _vm.$dataCheck(row.availableInventory, "--")
                                )
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              " " + _vm._s(_vm.editText.goods_stock) + ": "
                            ),
                            _c(
                              "span",
                              {
                                style:
                                  "color:" +
                                  _vm.compareCount(
                                    row.spuId
                                      ? row.spuInventory
                                      : row.skuInventory,
                                    row.safeInventory
                                  ),
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$dataCheck(
                                        row.spuId
                                          ? row.spuInventory
                                          : row.skuInventory,
                                        "--"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.editText.safe_stock) +
                                ": " +
                                _vm._s(_vm.$dataCheck(row.safeInventory, "--"))
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "status",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  (
                                    row.spuId
                                      ? !!row.spuStatus
                                      : !!row.skuStatus
                                  )
                                    ? _vm.$t("stores::store::goods::put_on")
                                    : _vm.$t("stores::store::goods::put_off")
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "opt",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          row.spuId
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "auth",
                                          rawName: "v-auth",
                                          value:
                                            "stores::products-info::detail",
                                          expression:
                                            "'stores::products-info::detail'",
                                        },
                                      ],
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleToDetail(row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.editText.detail) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3557853191
                ),
              }),
            ],
            1
          ),
          _c("importLogModal", {
            model: {
              value: _vm.importLogVisable,
              callback: function ($$v) {
                _vm.importLogVisable = $$v
              },
              expression: "importLogVisable",
            },
          }),
          _c("ImportDialog", {
            ref: "importDialog",
            on: { save: _vm.onSaveUpload, export: _vm.exportGoods },
            model: {
              value: _vm.importFileVisable,
              callback: function ($$v) {
                _vm.importFileVisable = $$v
              },
              expression: "importFileVisable",
            },
          }),
        ],
        1
      )
    : _c(
        "div",
        [
          _c("emptyCard", {
            attrs: {
              data: {
                title: _vm.$t("stores::products-info::empty_goods"),
                img: require("@/assets/images/emptyDefault/commodity@2x.png"),
                desc: _vm.$t("stores::products-info::empty_goods_tips"),
                buttons: [
                  {
                    click: _vm.onBindShop,
                    text: _vm.$t("stores::products-info::empty_bind_store"),
                    auth: "stores::store::add",
                  },
                ],
              },
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }